export type DigitKey = "a" | "b" | "c" | "d" | "e" | "f";
export type Digits = Record<DigitKey, string>;

export const DIGIT_KEYS: DigitKey[] = ["a", "b", "c", "d", "e", "f"];

// Deliberately flat (not `extends Record<DigitKey, string>`) — react-hook-form's
// generic Path resolution blows up ("excessive stack depth") on mapped-type field values.
export interface VerifyNumberFormValues {
  a: string;
  b: string;
  c: string;
  d: string;
  e: string;
  f: string;
  smsConsent: boolean;
}

export interface VerifyNumberProps {
  phoneNumber?: string;
  onChangeNumber: (shouldDisplay: boolean) => void;
  handleClose: () => void;
  onVerify: (digits: Digits) => void;
  onResend: () => void;
}
